export const capitalizeFirstLetter = (s) => {
  const sLower = s.toLowerCase()
  return sLower.charAt(0).toUpperCase() + sLower.slice(1)
}

export const removeWhiteSpaces = (s) => {
  return s.replace(/\s/g, '')
}